import Footer from 'components/Footer/Footer';
import Header from 'components/Header/Header';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withHomePageQuery, { WithHomePageQueryProps } from 'enhancers/withHomePageQuery';
import * as React from 'react';
import Headroom from 'react-headroom';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
}

type Props = IProps & IWithCountryProps & WithHomePageQueryProps;

export const DefaultPage: React.SFC<Props> = props => (
  <Container>
    <Headroom
      style={{
        background: 'rgb(57, 111, 176)',
        boxShadow: '1px 1px 1px rgba(0,0,0,0.25)',
        zIndex: 1000
      }}
    >
      <Header
        showGlobalRegistration={
          (props.country === 'global'
            ? !props.loading &&
              props.data &&
              props.data.fetch.Common.Registration &&
              props.data.fetch.Common.Registration.Active === 'yes'
            : !props.loading &&
              props.data &&
              props.data.fetch.Country.RegistrationPage &&
              props.data.fetch.Country.RegistrationPage
                .ShowRegistrationButton === 'yes') || false
        }
        buttonText={
          !props.loading &&
          props.data &&
          props.data.fetch.Country.HomePage &&
          props.data.fetch.Country.HomePage.SplashSection &&
          props.data.fetch.Country.HomePage.SplashSection.ButtonText
            ? props.data.fetch.Country.HomePage.SplashSection.ButtonText
            : 'Enter your team'
        }
        registerLink={
          !props.loading &&
          props.data &&
          props.data.fetch.Country.HomePage &&
          props.data.fetch.Country.HomePage.SplashSection &&
          props.data.fetch.Country.HomePage.SplashSection.SplashButtonLink
            ? props.data.fetch.Country.HomePage.SplashSection.SplashButtonLink
            : null
        }
      />
    </Headroom>
    <Content>{props.children}</Content>
    <Footer />
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  min-height: calc(100vh - 366px);
  @media (max-width: 749px) {
    margin-top: 90px;
  }
`;

export default withCountry(withHomePageQuery(DefaultPage));



// WEBPACK FOOTER //
// ./src/wrappers/DefaultPage/DefaultPage.tsx